import { render, staticRenderFns } from "./CompanyEditModuleMetaDataOnlineBackup.vue?vue&type=template&id=6db2c265&"
import script from "./CompanyEditModuleMetaDataOnlineBackup.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaDataOnlineBackup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db2c265')) {
      api.createRecord('6db2c265', component.options)
    } else {
      api.reload('6db2c265', component.options)
    }
    module.hot.accept("./CompanyEditModuleMetaDataOnlineBackup.vue?vue&type=template&id=6db2c265&", function () {
      api.rerender('6db2c265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaDataOnlineBackup.vue"
export default component.exports